import React from "react";
import {
  Button,
  Modal,
  Form,
  Table,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useMobileLicensing } from "./useEnableMobileLicensing";
import { IUser } from "../../common/types/userTypes";

const EnableMobileLicensing = ({ users, licenseDetails, disabled }) => {
  const {
    show,
    handleShow,
    handleClose,
    toggleStates,
    handleToggle,
    onSubmit,
    searchTerm,
    handleSearchChange,
    handleSearchKeyDown,
  } = useMobileLicensing(users, licenseDetails);

  const displayUsers =
    users
      ?.filter((user: IUser) => user.status !== "Invited")
      ?.filter((user: IUser) =>
        user.email.toLowerCase().includes(searchTerm.toLowerCase()),
      ) || [];

  const dynamicUsedCount = toggleStates.filter(
    (toggleUser) => toggleUser.enabled,
  ).length;

  const licenseLimitReached: boolean =
    dynamicUsedCount >= licenseDetails.totalLicenseCount;

  return (
    <>
      <Button variant="primary" onClick={handleShow} disabled={disabled}>
        Mobile Licensing
      </Button>

      <Modal
        show={show}
        onHide={handleClose}
        className="modal-container assign-roles-modal"
        centered
        dialogClassName="mobile-license-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Enable Mobile Licensing - {dynamicUsedCount}/
            {licenseDetails.totalLicenseCount}
          </Modal.Title>
        </Modal.Header>

        <Form onSubmit={onSubmit}>
          <Modal.Body>
            <div className="mobile-license-search">
              <Form.Control
                type="text"
                placeholder="Search user by email"
                value={searchTerm}
                onChange={handleSearchChange}
                onKeyDown={handleSearchKeyDown}
              />
            </div>
            <div className="user-scroll-container">
              <Table striped bordered hover responsive>
                <thead>
                  <tr>
                    <th>Email</th>
                    <th>Enable Licensing</th>
                  </tr>
                </thead>
                <tbody>
                  {displayUsers.length > 0
                    ? displayUsers.map((user: IUser) => {
                        const current = toggleStates.find(
                          (toggleUser) => toggleUser.email === user.email,
                        );
                        const isEnabled = current?.enabled || false;
                        const shouldDisable = licenseLimitReached && !isEnabled;

                        return (
                          <tr key={user.email}>
                            <td>{user.email}</td>
                            <td>
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  shouldDisable ? (
                                    <Tooltip id={`tooltip-${user._id}`}>
                                      Total license count limit reached
                                    </Tooltip>
                                  ) : (
                                    <></>
                                  )
                                }
                              >
                                <span>
                                  <Form.Check
                                    type="checkbox"
                                    id={`checkbox-${user._id}`}
                                    checked={isEnabled}
                                    disabled={shouldDisable}
                                    onChange={() => handleToggle(user.email)}
                                  />
                                </span>
                              </OverlayTrigger>
                            </td>
                          </tr>
                        );
                      })
                    : searchTerm.trim().length > 0 && (
                        <tr>
                          <td colSpan={2} className="text-center">
                            No user found
                          </td>
                        </tr>
                      )}
                </tbody>
              </Table>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button className="button-bg-white" onClick={handleClose}>
              Cancel
            </Button>
            <Button className="button-bg-blue" type="submit" disabled = {searchTerm.trim().length > 0 && displayUsers.length === 0}>
              Save
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default EnableMobileLicensing;
